export default __webpack_public_path__ + "static/media/Maharaja02.17bb94b6.jpg";